import {
  IInstagramDailyHistoricalMetrics,
  InstagramHashtagTopContentSortKey,
} from '@apis/instagram-hashtag/instagramHashtagApiModel';
import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
import { IInstagramPost } from '@models/IInstagramMediaItem';

export interface IInstagramHashtagInsightsState {
  content: IInstagramHashtagContent;
  errors: {
    fetchInstagramHashtagHistoricalMetricsError?: string;
    fetchInstagramHashtagTopContentError?: string;
    fetchMoreInstagramHashtagTopContentError?: string;
  };
  flags: {
    isEndOfInstagramHashtagTopContentReached: boolean;
    isFetchingInstagramHashtagHistoricalMetrics: boolean;
    isFetchingInstagramHashtagTopContent: boolean;
    isFetchingMoreInstagramHashtagTopContent: boolean;
  };
  metrics: IInstagramHashtagMetrics;
}

export interface IInstagramHashtagContent {
  items: IInstagramPost[];
  offset: number;
  sort: InstagramHashtagTopContentSortKey;
}

export interface IInstagramHashtagMetrics {
  dailyHistoricalMetrics: IInstagramDailyHistoricalMetrics[];
  overallMetrics: IInstagramHashtagOverallMetrics;
}

export interface IInstagramHashtagDailyMetricsNumbers {
  average: number;
  sum: number;
}

export interface IInstagramHashtagOverallMetrics {
  totalComments: number;
  totalInteractions: number;
  totalLikes: number;
  totalPosts: number;
}

export const HASHTAG_INSIGHTS_REQUEST_LIMIT = 50;
